import { useAuthStore } from '@/store/auth';
import { useCoworkerStore } from '@/store/coworker';
import { useVoiceModeStore } from '@/store/voiceMode';
import { requirePlusForVoice } from './requirePlusForVoice';

export function runMobileLaunchAction(action) {
  const auth = useAuthStore.getState();
  if (!auth.token || !auth.user?.id || auth._isSigningOut) return false;
  if (action === 'chat') { useCoworkerStore.getState().setComposerMode('chat'); return true; }
  if (action === 'work') { useCoworkerStore.getState().setComposerMode('coworker'); return true; }
  if (action !== 'voice' || !requirePlusForVoice({ title: 'Plus required', subtitle: 'Voice Mode requires Gab AI Plus.' })) return false;
  if (!useVoiceModeStore.getState().isActive) useVoiceModeStore.getState().actions.startVoiceMode(null);
  return true;
}
